import getNestedProperty from "@/utils/getNestedProperty";
import getFieldVisiblePath from "@/common/config/getFieldVisiblePath";

export default (resumeData, id, field) => {
    const path = getFieldVisiblePath(id, field);
    const value = getNestedProperty(resumeData, path);
    return value === undefined ? true : value
}
